import {
  CostModel,
  HtmlText,
  Integer,
  NonEmptyText,
  Url,
  UUID,
} from '@hc-frontend/core-types';
import z from 'zod';

export const FeaturedAd = z.object({
  id: UUID,
  logo: Url,
  title: NonEmptyText,
  content: HtmlText,
  provider: z.object({
    id: Integer,
    name: NonEmptyText,
    displayUrl: NonEmptyText,
    url: Url,
  }),
  link: Url,
  /**
   * @deprecated Use the provider.id instead, this field will be removed in the future.
   */
  creativeId: Integer,
  groupId: Integer,
  // TODO: move to an object with id or other more data
  campaignId: Integer,
  campaignName: NonEmptyText,
  dealType: CostModel,
  cpc: z.number(),
});

export type FeaturedAd = z.infer<typeof FeaturedAd>;
